import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import type { BugsnagErrorBoundary } from '@bugsnag/plugin-react';

const DISABLED_MODES = ['local', 'development'];

export const initBugsnag = (): void => {
  if (DISABLED_MODES.includes(import.meta.env.MODE)) return;

  const apiKey = import.meta.env.VITE_BUGSNAG_API_KEY;

  if (!apiKey) return;

  Bugsnag.start({
    apiKey,
    releaseStage: import.meta.env.VITE_BUGSNAG_RELEASE_STAGE,
    enabledReleaseStages: ['pre-prod', 'staging', 'production'],
    appVersion: import.meta.env.VITE_APP_VERSION,
    plugins: [new BugsnagPluginReact()],
  });
};

export const getErrorBoundary = (): BugsnagErrorBoundary | null => {
  const plugin = Bugsnag.getPlugin('react');

  return plugin ? plugin.createErrorBoundary(React) : null;
};
